import React from "react";

import { Button, IconButton, PopoverOrigin } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import Callout from "../../callout";

import "../styles/calloutMultiselect.sass";

// think about extending callout props
interface ICalloutMultiselectProps {
    items: Record<string, string>[];
    open: boolean;
    setOpen: (toSet: boolean) => void;
    anchorEl: HTMLElement | null;
    activeValue?: string;
    defaultValue?: string;
    selectedValues?: string[];
    anchorOrigin?: PopoverOrigin;
    transformOrigin?: PopoverOrigin;
    onSelectItem: (item: Record<string, string>) => void;
    onAddItem: (item: Record<string, string>) => void; // add button click
    onRemoveItem: (item: Record<string, string>) => void; // list item click
    fullSize?: boolean;
    calloutContentClassName?: string;
    calloutClassName?: string;
    footerContent?: JSX.Element;
    disableButtons?: boolean;
}

const CalloutMultiselect: React.FunctionComponent<ICalloutMultiselectProps> = ({
    items,
    open,
    anchorEl,
    selectedValues = [],
    activeValue = "",
    defaultValue = "",
    anchorOrigin,
    transformOrigin,
    onAddItem,
    onRemoveItem,
    onSelectItem,
    setOpen,
    fullSize = false,
    calloutContentClassName,
    calloutClassName,
    footerContent,
    disableButtons = false
}) => {
    const getActions = (isDefault: boolean, isSelected: boolean, item: Record<string, string>, index: number): JSX.Element => {
        if (isDefault) return <></>;

        let element: JSX.Element;
        if (isSelected)
            element = <IconButton
                id={`${index}-remove-btn`}
                size="small"
                onClick={() => {
                    onRemoveItem(item);
                }}
                className="action"
                disabled={disableButtons}
            >
                <ClearIcon htmlColor="#b72026" />
            </IconButton>;
        else
            element = <Button
                id={`${index}-add-btn`}
                variant="text"
                color="primary"
                onClick={() => {
                    onAddItem(item);
                }}
                className="action"
                disabled={disableButtons}
            >
                Add
            </Button>

        return element;
    }

    return (
        <Callout
            contentClassName={`callout-multiselect-content ${fullSize ? "full-size" : ""}${calloutContentClassName ? ` ${calloutContentClassName}` : ""}`}
            anchorEl={anchorEl}
            open={open}
            setOpen={setOpen}
            arrowStyle={{ display: "none" }}
            popoverProps={{
                anchorOrigin,
                transformOrigin
            }}
            fullSize={fullSize}
            calloutClassName={calloutClassName}
        >
            <div className="callout-multiselect-items">
                {items.map((item: Record<string, string>, i: number) => {
                    const isActive = item.key === activeValue;
                    const isDefault = item.key === defaultValue;
                    const isSelected = selectedValues.find((selectedItem) => selectedItem === item.key) !== undefined;

                    return (
                        <div key={item.key} className={`callout-multiselect-item ${isActive ? "selected" : ""}`}>
                            <Button 
                                id={`main-selectable-item-${i}`} 
                                style={{ textTransform: "none" }} 
                                className={`main-item ${isActive ? "selected" : ""}`} 
                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                    onSelectItem(item);
                                }}
                                disabled={disableButtons}
                            >
                                {item.value}
                            </Button>
                            {isDefault &&
                                <span className="callout-multiselect-default-item action">Default</span>}
                            {getActions(isDefault, isSelected, item, i)}
                        </div>
                    );
                })}
            </div>
            {footerContent}
        </Callout>
    );
}

export default CalloutMultiselect;
